
export async function latestNewsletter(id) {
    const response = await fetch('/api/boards/' + id);
    const board = await response.json();
    const boardId = board.boardId;
    return boardId;
}

/*
module.exports = global.config = {
    i18n: {
        welcome: {
            en: 'Welcome',
        }
        // rest of your translation object
    }
    // other global config variables you wish
};*/


// WEBPACK FOOTER //
// ./src/config.js